import { create } from 'zustand';

interface IImpersonatedUserStore {
  impersonatedUser: string;
  setImpersonatedUser: (user: string) => void;
  clear: () => void;
}

export const useImpersonatedUserStore = create<IImpersonatedUserStore>((set) => ({
  impersonatedUser: '',

  setImpersonatedUser: (user) => set(() => ({ impersonatedUser: user })),
  clear: () => set(() => ({ impersonatedUser: '' })),
}));
